import { isUndefined } from 'lodash-es';

import { THRESHOLD_COLOR_DEFAULT } from '../constants.js';
import type { GaugeChartThresholdIndicatorProps } from '../slots/ThresholdIndicator.js';
import type { GaugeChartThresholdIndicatorPropsInternal } from '../types/gauge-chart-config-internal.js';

export const applyThresholdDefaults = (
  threshold: GaugeChartThresholdIndicatorProps,
): GaugeChartThresholdIndicatorPropsInternal => {
  const showIndicatorDefault = isUndefined(threshold.color);

  return {
    value: threshold.value,
    showIndicator: threshold.showIndicator ?? showIndicatorDefault,
    color: threshold.color ?? THRESHOLD_COLOR_DEFAULT,
  };
};
